<template>
  <div class="container py-4">
    <div class="text-center mb-4">
      <h1>Выберите ваш план</h1>
      <p class="lead text-muted">
        Разблокируйте всю мощь AI-ассистента и готовьте без ограничений!
      </p>
    </div>

    <!-- Free Plan -->
    <div class="card mb-4 rounded-3 shadow-sm border-primary">
      <div class="card-header py-3">
        <h4 class="my-0 fw-normal text-center">Бесплатный</h4>
      </div>
      <div class="card-body">
        <h1 class="card-title pricing-card-title text-center">
          0₽<small class="text-muted fw-light">/мес</small>
        </h1>
        <ul class="list-unstyled mt-3 mb-4">
          <li>
            <i class="bi bi-check-circle-fill text-success"></i> Базовый поиск
            рецептов
          </li>
          <li>
            <i class="bi bi-exclamation-triangle-fill text-warning"></i>
            Ограниченное использование AI-ассистента
          </li>
        </ul>
        <button type="button" class="w-100 btn btn-lg btn-outline-secondary">
          Текущий план
        </button>
      </div>
    </div>

    <div class="row row-cols-1 row-cols-md-2 mb-3 text-center mt-3">
      <!-- Standard Plan -->
      <div class="col">
        <div class="card mb-4 rounded-3 shadow-sm border-primary">
          <div class="card-header py-3 text-white bg-primary border-primary">
            <h4 class="my-0 fw-normal">Стандарт</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              199₽<small class="text-muted fw-light">/мес</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>
                <i class="bi bi-check-circle-fill text-success"></i>
                Неограниченная генерация рецептов
              </li>
              <li>
                <i class="bi bi-check-circle-fill text-success"></i> Безлимитный
                чат с AI-ассистентом
              </li>
              <li>
                <i class="bi bi-check-circle-fill text-success"></i>
                Неограниченная публикация рецептов
              </li>
              <li>
                <i class="bi bi-check-circle-fill text-success"></i> Страница
                автора
              </li>
            </ul>
            <button
              type="button"
              class="w-100 btn btn-lg btn-primary"
              @click="selectPlan('standard', 199)"
            >
              Выбрать
            </button>
          </div>
        </div>
      </div>

      <!-- Premium Plan -->
      <div class="col">
        <div class="card mb-4 rounded-3 shadow-sm">
          <div class="card-header py-3">
            <h4 class="my-0 fw-normal">Премиум</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              499₽<small class="text-muted fw-light">/мес</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li><strong>Все функции "Стандарт"</strong></li>
              <li>
                <i class="bi bi-gem text-info"></i> Расширенные фильтры поиска
              </li>
              <li>
                <i class="bi bi-gem text-info"></i> Доступ к эксклюзивным
                рецептам
              </li>
              <li>
                <i class="bi bi-gem text-info"></i> Приоритетная поддержка
                (скоро)
              </li>
            </ul>
            <button
              type="button"
              class="w-100 btn btn-lg btn-outline-primary"
              @click="selectPlan('premium', 499)"
            >
              Выбрать
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageSubscription",
  methods: {
    async selectPlan(level, price) {

      // Placeholder for payment logic
      console.log(`Selected plan: ${level} for ${price} RUB per month`);
      try {
        const response = await this.sendCmd(
          "subscription.createInvoice",
          JSON.stringify({ level: level, months: 1 })
        );
        const invoice = JSON.parse(response);

        if (window.Telegram && window.Telegram.WebApp && invoice.url) {
          if (window.Telegram.WebApp.isVersionAtLeast("6.1")) {
            // Ideal case: use the native invoice popup
            window.Telegram.WebApp.openInvoice(invoice.url, (status) => {
              if (status === "paid") {
                // TODO: Handle successful payment (e.g., show a success message and update profile)
                alert(
                  "Оплата прошла успешно! Ваша подписка будет активирована в ближайшее время."
                );
              } else if (status === "failed") {
                alert("Не удалось обработать платеж. Пожалуйста, попробуйте снова.");
              }
            });
          } else {
            // Fallback for older clients: open the invoice link directly.
            window.Telegram.WebApp.openLink(invoice.url);
          }
        } else {
          // Not in a Telegram environment
          alert(`Вы выбрали план "${level}". Ссылка для оплаты (доступна только в Telegram): ${invoice.url}`);
        }
      } catch (error) {
        console.error("Failed to create invoice:", error);
        alert("Не удалось создать счет на оплату. Пожалуйста, попробуйте позже.");
      }
    },
  },
};
</script>
